export class Utils {
  formatToDateThai(dateStr) {
    if (dateStr) {
      let date;
      if (typeof dateStr === 'string') {
        dateStr = dateStr.substr(0, 10);
        date = new Date(dateStr);
      } else {
        date = dateStr;
      }
      const monthTh = [
        'ม.ค.',
        'ก.พ.',
        'มี.ค.',
        'เม.ย.',
        'พ.ค.',
        'มิ.ย.',
        'ก.ค.',
        'ส.ค.',
        'ก.ย.',
        'ต.ค.',
        'พ.ย.',
        'ธ.ค.'
      ];

      return `${date.getDate()} ${monthTh[date.getMonth()]} ${date.getFullYear() + 543}`;
    }
    return '';
  }

  formatNumber(number) {
    if (number !== null && number !== undefined) {
      const num = number.toString();
      if (num !== '') {
        const dotPplit = num.split('.');
        dotPplit[0] = dotPplit[0].replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
        return dotPplit.join('.');
      }
    }
    return '-';
  }

  getLocalTime() {
    return new Date(Date.now() - new Date().getTimezoneOffset() * 60000);
  }

  getLocalDate(time) {
    if (!time) {
      time = new Date();
    }
    return [
      time.getFullYear(),
      `0${time.getMonth() + 1}`.substr(-2),
      `0${time.getDate()}`.substr(-2)
    ].join('-');
  }

  getMinDate(date) {
    if (date) {
      date = date.split(' ')[0].split('T')[0];
      if (isNaN(Date.parse(date))) {
        return '';
      }
      const td = new Date(date);
      td.setFullYear(td.getFullYear() - 1);
      return this.getLocalDate(td);
    }
    return '';
  }

  startDateChanged(startDate, endDate) {
    if (!startDate || !endDate) {
      return false;
    }
    if (startDate > endDate) {
      return this.endDateChanged(endDate, startDate);
    }
    // const today = this.getLocalDate();
    let maxDate;
    let nextYear = new Date(startDate);
    nextYear.setFullYear(nextYear.getFullYear() + 1);
    nextYear = this.getLocalDate(nextYear);
    // if (nextYear > today) {
      // maxDate = today;
    // } else {
      maxDate = nextYear;
    // }
    if (endDate > maxDate) {
      endDate = maxDate;
    }
    return { startDate, endDate };
  }

  endDateChanged(startDate, endDate) {
    if (!startDate || !endDate) {
      return false;
    }
    if (endDate < startDate) {
      return this.startDateChanged(endDate, startDate);
    }
    let minDate = new Date(endDate);
    minDate.setFullYear(minDate.getFullYear() - 1);
    minDate = this.getLocalDate(minDate);
    if (startDate < minDate) {
      startDate = minDate;
    }
    return { startDate, endDate };
  }
}
